import { SmoothScroll } from './SmoothScroll';

/**
 * ページトップへ戻る
 */
export class PageTop {
  /**
   * 対象の要素オブジェクト
   */
  private readonly $element: JQuery;

  /**
   * windowオブジェクト
   */
  private readonly $window: JQuery<Window>;

  /**
   * 移動スピード
   */
  private readonly speed: number = 0;

  /**
   * windowの高さ
   */
  private winHeight: number = 0;

  /**
   * windowの幅
   */
  private winWidth: number = 0;

  /**
   * timeoutID
   */
  private timeoutID: any = 0;

  /**
   * コンストラクタ
   * @param element 対象の要素セレクタ
   * @param speed 移動スピード
   */
  constructor(element: string, speed: number = 300) {
    this.$element = $(element);
    this.$window = $(window);

    if (! this.$element[0]) {
      return;
    }

    new SmoothScroll(element);
    this.winHeight = this.getWinHeight();
    this.speed = speed;
    this.$window.on('resize', this.resizeListener);
    this.$window.on('scroll', this.scrollListener);
  }

  /**
   * windowの高さを取得
   * @returns windowの高さ
   */
  private getWinHeight(): number {
    return (window.innerHeight) ? window.innerHeight : this.$window.height()!;
  }

  /**
   * windowの幅を取得
   * @returns windowの幅
   */
  private getWinWidth(): number {
    return (window.innerWidth) ? window.innerWidth : this.$window.width()!;
  }

  /**
   * リサイズイベントリスナー
   * @param event イベントオブジェクト
   */
  private resizeListener = (event: JQueryEventObject): void => {
    clearTimeout(this.timeoutID);
    this.timeoutID = setTimeout((): void => {
      this.winHeight = this.getWinHeight();
      this.winWidth = this.getWinWidth();
    }, 80);
  }

  /**
   * スクロールイベントリスナー
   * @param event イベントオブジェクト
   */
  private scrollListener = (event: JQueryEventObject): void => {
    let top = this.$window.scrollTop()!;
    let wh = this.winHeight;
    // 画面の1/2より下にスクロールしたらフェードイン
    if (top > wh / 2) {
      this.$element.fadeIn(this.speed);
    } else {
      this.$element.fadeOut(this.speed);
    }
    // SPのみフッターでsticky風に止める
    let ww = this.winWidth;
    let dh = $(document).height()!;
    let sns = $('.footer__sns').offset()!.top;
    if (ww < 1020) {
      if ((top + wh) > (sns + 60)) {
        this.$element.css({
          position: 'absolute',
          bottom: dh - sns - 30,
        });
      } else {
        this.$element.css({
          position: 'fixed',
          bottom: '32px'
        });
      }
    }
  }
}
